import { ajaxSend } from '../../../api/api';

export function getQueues() {
  return ajaxSend({
    path: '/v1/queues',
  });
}
